import React, { FC } from 'react'
import { IonPage } from "@ionic/react";
import Login from '../components/Login'
import './LogIn.scss'

const LogIn: FC = () => {

  return (
    <IonPage className="cheap_desktop">
      <Login />
    </IonPage>
  )
}
export default LogIn
